import React, { useContext, useEffect, useState } from 'react';
import { Tabs, Card, Typography, Row, Col } from 'antd';
import moment from 'moment';
import { useFeedbackFormStore } from './store';
import { CustomerProps } from './ShowCustomer';

const { TabPane } = Tabs;
const { Text } = Typography;

export default function CustomerFeedbackLead({ customer, formNames }) {
  const { isLoading, isError, fetchfeedbackFormFetchData } = useFeedbackFormStore();
  const [responsesByForm, setResponsesByForm] = useState({});
  const [activeForm, setActiveForm] = useState(formNames[0]);
  const [activeTab, setActiveTab] = useState(null);
  const { caseId } = useContext(CustomerProps);

  // Fetch feedback data for the active form when the tab changes
  useEffect(() => {
    if (customer?.id && activeForm && !responsesByForm[activeForm]) {
      const fetchData = async () => {
        try {
          const response = await fetchfeedbackFormFetchData(customer.id, activeForm);
          setResponsesByForm((prevResponses) => ({
            ...prevResponses,
            [activeForm]: response?.responses || [], // Save responses for this form or set an empty array
          }));
        } catch (error) {
          console.error(`Error fetching data for form: ${activeForm}`, error);
        }
      };
      fetchData();
    }
  }, [customer?.id, activeForm, responsesByForm]);

  // Set the first response date as the active tab when form data is fetched
  useEffect(() => {
    if (responsesByForm[activeForm]?.length > 0) {
      const firstResponseDate = moment(responsesByForm[activeForm][0]?.formFillDate).format('MMMM Do YYYY');
      setActiveTab(firstResponseDate);
    } else {
      setActiveTab(null); // Reset active tab if no responses are available
    }
  }, [responsesByForm, activeForm]);

  // Handle form tab change
  const handleFormChange = (key) => {
    setActiveForm(key);
    setActiveTab(null); // Reset date tab when form changes
  };

  // Handle date tab change
  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <>
      {isLoading && <p>Loading feedback responses...</p>}
      {!isLoading  && (
        <>
          {/* Tabs for form names */}
          <Tabs activeKey={activeForm} onChange={handleFormChange} type="card">
            {formNames.map((form) => (
              <TabPane tab={form} key={form}>
                {/* Display feedback responses or no data message for the selected form */}
                {responsesByForm[form]?.length > 0 ? (
                  <>
                    {/* Tabs for dates */}
                    <Tabs activeKey={activeTab} onChange={handleTabChange} type="card">
                      {responsesByForm[form].map((response) => (
                        <TabPane
                          tab={moment(response.formFillDate).format('MMMM Do YYYY')}
                          key={moment(response.formFillDate).format('MMMM Do YYYY')}
                        />
                      ))}
                    </Tabs>

                    {/* Display feedback for the selected date */}
                    <Row gutter={[16, 16]} style={{ marginTop: '20px' }}>
                      {responsesByForm[form]
                        ?.find((response) => moment(response.formFillDate).format('MMMM Do YYYY') === activeTab)
                        ?.responses.map((question) => (
                          <Col span={8} key={question._id}>
                            <Card
                              bordered={true}
                              style={{
                                borderRadius: '8px',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                height: '100%',
                              }}
                            >
                              <Text strong>{question.question}</Text>
                              <div style={{ marginTop: '10px' }}>
                                <Text type="success">
                                  {Array.isArray(question.reply) ? question.reply.join(', ') : question.reply}
                                </Text>
                              </div>
                            </Card>
                          </Col>
                        ))}
                    </Row>
                  </>
                ) : (
                  <p>No feedback responses found for this form.</p>
                )}
              </TabPane>
            ))}
          </Tabs>
        </>
      )}
    </>
  );
}
